<template>

  <v-footer
  	v-if="!$route.path.match(/^\/textbook/)"
  	app dark padless absolute
  >
    <v-row justify="space-around" align="center" no-gutters>

    	<v-spacer> </v-spacer>
    	<v-spacer> </v-spacer>

    	<div><v-btn
			v-for="c in $g.cmn"
			:key="c.icon"
			color="white"
			text
			rounded
			class="my-2"
		>
		<a :href="c.url">
			<v-icon color="white"> {{ $mdi[c.icon] }} </v-icon>
		</a>
		
		</v-btn></div>

		<v-spacer> </v-spacer>

		<v-spacer v-if="$vuetify.breakpoint.xs"> </v-spacer>
		<div v-else style="width:300px;vertical-align:top;font-family: Arial;font-size:9pt;line-height: normal">
		<a rel="license" href="//responsivevoice.org/"><img title="ResponsiveVoice Text To Speech" src="https://responsivevoice.org/wp-content/uploads/2014/08/120x31.png" style="float:left;padding-right:2px" /></a><span xmlns:dct="https://purl.org/dc/terms/" property="dct:title"><a href="//responsivevoice.org/" target="_blank" title="ResponsiveVoice Text To Speech">ResponsiveVoice</a></span> used under <a rel="license" href="https://creativecommons.org/licenses/by-nc-nd/4.0/" title="Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License">Non-Commercial License</a></div>
		<div style="clear:both;">&nbsp;</div>


    </v-row>
  </v-footer>

</template>

<script>

export default {
	components: {},
	data() {
		return {
		}
	},
	methods: {

	},
	created() {
		
	}
}
</script>
